import { cn } from '@/lib/utils';

export type FilterKey =
  | 'specialty'
  | 'verified_contacts'
  | 'has_fax'
  | 'portal_eligible'
  | 'has_request_plan';

interface FilterChip {
  key: FilterKey;
  label: string;
  /** Inactive background color — each chip gets its own tint */
  inactiveBg: string;
}

const FILTER_CHIPS: FilterChip[] = [
  { key: 'specialty', label: 'Specialty', inactiveBg: 'bg-[#F1EFFF]' },
  { key: 'verified_contacts', label: 'Verified contacts', inactiveBg: 'bg-[#EDFFF0]' },
  { key: 'has_fax', label: 'Has fax', inactiveBg: 'bg-zinc-100' },
  { key: 'portal_eligible', label: 'Portal eligible', inactiveBg: 'bg-zinc-100' },
  { key: 'has_request_plan', label: 'Has request plan', inactiveBg: 'bg-zinc-100' },
];

interface FilterChipsProps {
  activeFilters: Set<FilterKey>;
  onToggle: (key: FilterKey) => void;
  className?: string;
}

export const FilterChips = ({
  activeFilters,
  onToggle,
  className,
}: FilterChipsProps) => {
  return (
    <div className={cn('flex flex-wrap gap-2', className)}>
      {FILTER_CHIPS.map((chip) => {
        const isActive = activeFilters.has(chip.key);
        return (
          <button
            key={chip.key}
            type="button"
            onClick={() => onToggle(chip.key)}
            className={cn(
              'inline-flex items-center rounded-full px-3 py-1 text-xs font-medium transition-colors',
              'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary',
              isActive
                ? 'bg-primary text-white'
                : cn(chip.inactiveBg, 'text-info hover:opacity-80'),
            )}
          >
            {chip.label}
          </button>
        );
      })}
    </div>
  );
};
